<template>
  <div>
    <CCard class="bg-style3">
      <CCardBody>
      <CRow>
        <CCol>
          <CDataTable
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :fields="fields"
            :items="assetsList"
            :items-per-page="small ? 50 : 5"
            :dark="dark"
            pagination
          >
            <template #index="{index}"><td>{{ index+1 }}</td></template>
            <template #title="{item}"><td>{{ item.title }}</td></template>
            <template #description="{item}"><td>{{ item.description }}</td></template>
            <template #category="{item}"><td>{{ item.category }}</td></template>
            <template #subtype="{item}"><td>{{ item.subtype }}</td></template>
            <template #status="{item}"><td>{{ item.status }}</td></template>
            <template #amount="{item}"><td>{{ Number(item.amount||0).toLocaleString('en-US') }}</td></template>

            <template #action="{item}">
              <td class="text-center">
                <CButton size="sm" color="info" shape="pill" variant="outline" class="mr-1" v-c-tooltip.hover.click="'แก้ไข'"
                         @click="openAssetModal(item)" :disabled="!canEditAssets ">
                         
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton size="sm" color="warning" shape="pill" variant="outline" class="mr-1" v-c-tooltip.hover.click="'จำนวน'"
                        @click="openStockModal(item)" :disabled="!canEditAssets">
                  <CIcon name="cil-Equalizer"/>
                </CButton>
                <CButton size="sm" color="danger" shape="pill" variant="outline" class="mr-1" v-c-tooltip.hover.click="'ลบ'"
                        @click="confirmDelete(item)" :disabled="!canEditAssets">
                  <CIcon name="cil-trash"/>
                </CButton>
              </td>
            </template>
          </CDataTable>
          <div class="d-flex justify-content-end align-items-center mr-2">
            <CButton size="sm" shape="pill" v-c-tooltip.hover.click="'เพิ่ม'" variant="outline" color="info" @click="openAssetModal()" :disabled="!canEditAssets">
              <CIcon name="cil-plus" class="me-2"/>
            </CButton>
          </div>
        </CCol>
      </CRow>
      </CCardBody>
    </CCard>

    <!-- Modal Add/Edit Asset -->
    <CModal
      :title="isEditing ? 'แก้ไขสินทรัพย์' : 'เพิ่มสินทรัพย์'"
      :show.sync="showAddModal"
      size="lg"
      :centered="true"
      class="modal-rounded"
    >
      <template #body-wrapper>
        <div style="padding: 1rem;">
          <div class="form-group">
            <label>ชื่อสินทรัพย์</label>
            <input type="text" v-model="formData.title" class="form-control" />
          </div>

          <div class="form-group">
            <label>ประเภท</label>
            <select v-model="formData.category" class="form-control">
              <option v-for="opt in getCategoryOptions()" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
            </select>
          </div>

          <div class="form-group">
            <label>ประเภทย่อย</label>
            <select v-model="formData.subtype" class="form-control">
              <option v-for="opt in getSubtypeOptions()" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
            </select>
          </div>

          <div class="form-group">
            <label>สถานะ</label>
            <select v-model="formData.status" class="form-control">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div class="form-group" v-if="!isEditing">
            <label>จำนวนเริ่มต้น</label>
            <input type="number" v-model.number="formData.currentstock" min="0" class="form-control" />
          </div>

          <div class="form-group">
            <label>รายละเอียด</label>
            <textarea v-model="formData.description" class="form-control" rows="3"></textarea>
          </div>
        </div>
      </template>
      <template #footer>
        <CButton class="mr-2" size="sm" color="danger" shape="pill" variant="outline" @click="closeAssetModal">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-ban" size="sm"/> CANCEL </span>
        </CButton>
        <CButton size="sm" color="success" shape="pill" variant="outline" @click="saveAsset">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-save" size="sm"/> SUBMIT </span>
        </CButton>
      </template>
    </CModal>

    <!-- Modal Adjust Stock -->
    <CModal
      title="ปรับจำนวนสินทรัพย์"
      :show.sync="showStockModal"
      :centered="true"
      class="modal-rounded"
    >
      <template #body-wrapper>
        <div style="padding: 1rem;">
          <div class="form-group">
            <label>จำนวนเพิ่ม/ลด</label>
            <input type="number" v-model.number="stockAmount" min="0" class="form-control" />
          </div>

          <div class="form-group">
            <label>ประเภทการปรับ</label>
            <select v-model="stockType" class="form-control">
              <option :value="true">เพิ่ม</option>
              <option :value="false">ลด</option>
            </select>
          </div>
        </div>
      </template>
      <template #footer>
        <CButton class="mr-2" size="sm" color="danger" shape="pill" variant="outline" @click="closeStockModal">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-ban" size="sm"/> CANCEL </span>
        </CButton>
        <CButton size="sm" color="success" shape="pill" variant="outline" @click="saveStock">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-save" size="sm"/> SUBMIT </span>
        </CButton>
      </template>
    </CModal>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name:'Assetstable',
  data(){ 
    return {
      assetsList:[], 
      showAddModal:false, 
      showStockModal:false,
      formData:{title:'',description:'',category:'',subtype:'',currentstock:0},
      isEditing:false, 
      editingId:null,
      stockAsset:null, 
      stockAmount:0, 
      stockType:true,
      status:'active' 
    }
  },
  props:{ 
    icon:{type:String,default:'cil-inbox'}, 
    caption:{type:String,default:'รายการสินทรัพย์'}, 
    fields:{type:Array,default:()=>[
      {key:'index',label:'#',_style:'width:20px;text-align:center'},
      {key:'title',label:'ชื่อสินทรัพย์'},
      /*{key:'description',label:'รายละเอียด'},*/
      {key:'category',label:'ประเภท'},
      // {key:'subtype',label:'ประเภทย่อย'},
      {key:'amount',label:'จำนวน'},
      {key:'status',label:'สถานะ'},
      {key:'action',label:'จัดการ',_style:'width:140px; text-align:center'}
    ]}
  },

  created(){ 
    this.loadAllData() 
  },

  methods:{
    loadAllData(){
      this.$store.dispatch('Assets/category')
      this.$store.dispatch('Assets/subtype')
      this.$store.dispatch('Assets/assets')
    },
    getCategoryOptions(){ 
      return (this.categories || []).map(c => ({ value: c._id, label: c.title[0]?.value || '-' })) 
    },
    getSubtypeOptions(){ 
      return (this.subtypes || []).map(s => ({ value: s._id, label: s.title[0]?.value || '-' })) 
    },

    openAssetModal(asset){
      if (!this.canEditAssets) return;
       console.log('เปิด Asset:', asset);
      if(asset){
        this.isEditing=true
        this.editingId=asset._id
        this.formData={
          title: asset.title[0]?.value || '',
          description: asset.description[0]?.value || '',
          category: asset.categoryId || this.getCategoryOptions()[0]?.value || '',
          subtype: asset.subtypeId || this.getSubtypeOptions()[0]?.value || '',
          status: asset.status || 'active' ,
          currentstock:0
        }
      }else{
        this.isEditing=false
        this.editingId=null
        this.formData={
          title:'',
          description:'',
          category:this.getCategoryOptions()[0]?.value || '',
          subtype:this.getSubtypeOptions()[0]?.value || '',
          status:'active',
          currentstock:0
        }
      }
      this.showAddModal=true
    },
    closeAssetModal(){ this.showAddModal=false },

    saveAsset(){
      if (!this.canEditAssets) return;
      const data = {
        _id: this.isEditing ? this.editingId : undefined,
        title:[{key:this.lang,value:this.formData.title}],
        description:[{key:this.lang,value:this.formData.description}],
        category:this.formData.category,
        subtype:this.formData.subtype,
        currentstock: this.isEditing ? undefined : Number(this.formData.currentstock),
        status: this.formData.status
      }
      const action = this.isEditing?'Assets/update':'Assets/create'
      this.$store.dispatch(action,data)
        .then(()=> Swal.fire('สำเร็จ','บันทึกเรียบร้อย','success'))
        .catch(()=> Swal.fire('ผิดพลาด','ไม่สามารถบันทึกได้','error'))
        .finally(()=> this.closeAssetModal())
    },

    openStockModal(asset){ 
      if (!this.canEditAssets) return;
      this.stockAsset=asset; 
      this.stockAmount=0; 
      this.stockType=true; 
      this.showStockModal=true 
    },
    closeStockModal(){ 
      this.showStockModal=false; 
      this.stockAsset=null; 
      this.stockAmount=0 
    },
    saveStock(){
      if (!this.canEditAssets) return;
      if(!this.stockAsset) return
      const updatedAsset = {
        _id: this.stockAsset._id,
        stockChange: { amount: Number(this.stockAmount), state: this.stockType }
      }
      this.$store.dispatch('Assets/update',updatedAsset)
        .then(()=> Swal.fire('สำเร็จ','ปรับ Stock เรียบร้อย','success'))
        .catch(()=> Swal.fire('ผิดพลาด','ไม่สามารถปรับ Stock ได้','error'))
        .finally(()=> this.closeStockModal())
    },

    confirmDelete(asset){
      if (!this.canEditAssets) return;
      Swal.fire({
        title:'คุณต้องการลบสินทรัพย์นี้หรือไม่?',
        icon:'warning',
        showCancelButton:true,
        confirmButtonText:'ลบ',
        cancelButtonText:'ยกเลิก'
      }).then(result=>{
        if(result.isConfirmed){
          this.$store.dispatch('Assets/remove',asset._id)
            .then(()=> Swal.fire('สำเร็จ','ลบสินทรัพย์เรียบร้อย','success'))
            .catch(()=> Swal.fire('ผิดพลาด','ไม่สามารถลบได้','error'))
        }
      })
    }
  },

  computed:{
    ...mapGetters({
      assets:'Assets/assets',
      categories:'Assets/category',
      subtypes:'Assets/subtype',
      selectedUser:'Auth/selectedUser',
      lang:'setting/lang'
    }),
    allRoles() {
    return this.selectedUser?.authen?.flatMap(a => a.roles) || [];
  },
  canEditAssets() {
    return this.allRoles.includes("1")|| this.allRoles.includes("3");
  },
  },
  watch:{
    assets(val){ this.assetsList=val||[] }
  },
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  font-weight: 600;
  margin-bottom: 0.25rem;
  display: block;
}
.form-control {
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid #e9ecef;
}

::v-deep .pagination {
  justify-content: flex-start !important;
  margin-left: 20px;
}

::v-deep .modal-rounded .modal-content {
  border-radius: 1rem !important;
}
</style>
